'use strict';

export default function isCancel(value) {
  return !!(value && value.__CANCEL__);
}



//////////////////
// WEBPACK FOOTER
// ./~/_axios@1.4.0@axios/lib/cancel/isCancel.js
// module id = 62
// module chunks = 1